import axios from 'axios';

// Get backend URL from environment
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

// Ensure HTTPS
const backendURL = BACKEND_URL.startsWith('http://') 
  ? BACKEND_URL.replace('http://', 'https://') 
  : BACKEND_URL;

// Create axios instance with default config
const api = axios.create({
  baseURL: `${backendURL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to ensure HTTPS
api.interceptors.request.use(
  (config) => {
    // Force HTTPS
    if (config.url && config.url.startsWith('http://')) {
      config.url = config.url.replace('http://', 'https://');
    }
    if (config.baseURL && config.baseURL.startsWith('http://')) {
      config.baseURL = config.baseURL.replace('http://', 'https://');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized - could redirect to login
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register') {
        // Only redirect if not already on auth pages
        // window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { backendURL };
